<template>
  <div>
    <v-card
        height="350"
        class="rounded-lg white" flat
    >
      <v-card-title class=" mr-3  secondary--text" style="font-size: medium; margin-top: -10px">
        <v-img class="ml-3" src="/img/icons/docs.svg" max-width="25" max-height="25"></v-img>
        آخرین حساب های تعریف شده
        <v-spacer></v-spacer>
        <v-tooltip right>
          <template v-slot:activator="{ on, attrs }">
            <v-btn v-bind="attrs" v-on="on" fab icon class="mr-3" href="/panel/accounts/tree" target="_blank">
              <v-img class="" src="/img/icons/info_circle.svg" max-width="23"></v-img>
            </v-btn>
          </template>
          نمایش درخت حساب ها
        </v-tooltip>
        <v-tooltip right color="secondary">
          <template v-slot:activator="{ on, attrs }">
            <v-btn v-bind="attrs" v-on="on" fab icon class="" @click="createNewAccount(openTab)">
              <v-img class="" src="/img/icons/plus_doc.svg" max-width="26"></v-img>
            </v-btn>
          </template>
          ثبت حساب جدید
        </v-tooltip>
      </v-card-title>
      <v-tabs style="margin-top: -10px" class="rounded-lg white--text" v-model="openTab"
              background-color="lightSecondary" color="primary">
        <v-tab class="white--text mr-5" active-class=" secondary mr-5" @click="checkAndGet(0)">
          <span>گروه</span>
        </v-tab>
        <v-tab class="white--text " active-class=" secondary" @click="checkAndGet(1)">
          <span>کل</span>
        </v-tab>
        <v-tab class="white--text " active-class=" secondary" @click="checkAndGet(2)">
          <span>معین</span>
        </v-tab>
        <v-tab class="white--text " active-class=" secondary" @click="checkAndGet(3)">
          <span class>تفضیلی</span>
        </v-tab>
        <v-tab class="white--text " active-class=" secondary" @click="getFloatAccountGroups()">
          <span class>گروه شناور</span>
        </v-tab>
        <v-tab class="white--text " active-class=" secondary" @click="getFloatAccounts()">
          <span class>شناور</span>
        </v-tab>
        <v-tab-item class="pt-4">
          <v-simple-table class="mr-2 ml-2 rounded-b-lg">
            <template v-slot:default>
              <thead>
              <tr>
                <th class="text-center">
                  ردیف
                </th>
                <th class="text-center">
                  کد حساب
                </th>
                <th class="text-center">
                  نام حساب
                </th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="(group, index) in groups" @click="$router.push(toAcoount(group.id,  0,))">
                <td class="text-center">{{ index + 1 }}</td>
                <td class="text-center">{{ group.code }}</td>
                <td class="text-center">{{ group.name }}</td>
              </tr>
              </tbody>
            </template>
          </v-simple-table>
        </v-tab-item>
        <v-tab-item class="pt-4">
          <v-simple-table class="mr-2 ml-2 rounded-b-lg">
            <template v-slot:default>
              <thead>
              <tr>
                <th class="text-center">
                  ردیف
                </th>
                <th class="text-center">
                  کد حساب
                </th>
                <th class="text-center">
                  نام حساب
                </th>
                <th class="text-center">
                  نوع حساب
                </th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="(kol, index) in kols">
                <td class="text-center">{{ index + 1 }}</td>
                <td class="text-center">{{ kol.code }}</td>
                <td class="text-center">{{ kol.name }}</td>
                <td class="text-center">{{ kol.type.name }}</td>
              </tr>
              </tbody>
            </template>
          </v-simple-table>
        </v-tab-item>
        <v-tab-item class="pt-4">
          <v-simple-table class="mr-2 ml-2 rounded-b-lg">
            <template v-slot:default>
              <thead>
              <tr>
                <th class="text-center">
                  ردیف
                </th>
                <th class="text-center">
                  کد حساب
                </th>
                <th class="text-center">
                  نام حساب
                </th>
                <th class="text-center">
                  نوع حساب
                </th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="(moein, index) in moeins">
                <td class="text-center">{{ index + 1 }}</td>
                <td class="text-center">{{ moein.code }}</td>
                <td class="text-center">{{ moein.name }}</td>
                <td class="text-center">{{ moein.type.name }}</td>
              </tr>
              </tbody>
            </template>
          </v-simple-table>
        </v-tab-item>
        <v-tab-item class="pt-4">
          <v-simple-table class="mr-2 ml-2 rounded-b-lg">
            <template v-slot:default>
              <thead>
              <tr>
                <th class="text-center">
                  ردیف
                </th>
                <th class="text-center">
                  کد حساب
                </th>
                <th class="text-center">
                  نام حساب
                </th>
                <th class="text-center">
                  نوع حساب
                </th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="(tafsili, index) in tafsilis">
                <td class="text-center">{{ index + 1 }}</td>
                <td class="text-center">{{ tafsili.code }}</td>
                <td class="text-center">{{ tafsili.name }}</td>
                <td class="text-center">{{ tafsili.type.name }}</td>
              </tr>
              </tbody>
            </template>
          </v-simple-table>
        </v-tab-item>
        <v-tab-item class="pt-4">
          <v-simple-table class="mr-2 ml-2 rounded-b-lg">
            <template v-slot:default>
              <thead>
              <tr>
                <th class="text-center">
                  ردیف
                </th>
                <th class="text-center">
                  نام گروه حساب شناور
                </th>
                <th class="text-center">
                  توضیحات
                </th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="(floatGroup, index) in floatGroups">
                <td class="text-center">{{ index + 1 }}</td>
                <td class="text-center">{{ floatGroup.name }}</td>
                <td class="text-center">{{ floatGroup.explanation }}</td>
              </tr>
              </tbody>
            </template>
          </v-simple-table>
        </v-tab-item>
        <v-tab-item class="pt-4">
          <v-simple-table class="mr-2 ml-2 rounded-b-lg">
            <template v-slot:default>
              <thead>
              <tr>
                <th class="text-center">
                  ردیف
                </th>
                <th class="text-center">
                  نام حساب شناور
                </th>
                <th class="text-center">
                  توضیحات
                </th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="(float, index) in floats">
                <td class="text-center">{{ index + 1 }}</td>
                <td class="text-center">{{ float.name }}</td>
                <td class="text-center">{{ float.explanation }}</td>
              </tr>
              </tbody>
            </template>
          </v-simple-table>
        </v-tab-item>


      </v-tabs>

    </v-card>
  </div>
</template>
<script>


export default {
  name: "LastAccountsTabs",
  components: {},
  data() {
    return {
      openTab: 3,
      groups: [],
      kols: [],
      moeins: [],
      tafsilis: [],
      floatGroups: [],
      floats: [],
    }
  },
  mounted() {
    this.checkAndGet(3)
  },

  methods: {
    checkAndGet(level){
      if (level == 0) {
        if (this.groups.length == 0){
          this.getAccounts(level)
        }
      }
      else if (level == 1) {
        if (this.kols.length == 0){
          this.getAccounts(level)
        }
      }
      else if (level == 2) {
        if (this.moeins.length == 0){
          this.getAccounts(level)
        }
      }
      else if (level == 3) {
        if (this.tafsilis.length == 0){
          this.getAccounts(level)
        }
      }
    },
    getAccounts(level) {
      let api_url = `reports/lists/accounts?limit=5&level=${level}&offset=0&ordering=-id&search=`
      this.request({
        url: this.endpoint(api_url),
        method: "get",
        success: data => {
          if (level == 0){
            this.groups = data.results
          } else if (level == 1) {
            this.kols = data.results
          } else if (level == 2) {
            this.moeins = data.results
          } else {
            this.tafsilis = data.results
          }
        },
      })
    },
    getFloatAccounts() {
      if (this.floats.length == 0){
        let api_url = `reports/lists/floatAccounts?limit=5&offset=0&search=`
        this.request({
          url: this.endpoint(api_url),
          method: "get",
          success: data => {
            this.floats = data.results
          },
        })

      }
    },
    getFloatAccountGroups() {
      if (this.floatGroups.length == 0) {
        let api_url = `reports/lists/floatAccountGroups?limit=5&offset=0&search=`
        this.request({
          url: this.endpoint(api_url),
          method: "get",
          success: data => {
            this.floatGroups = data.results
          },
        })
      }
    },
    createNewAccount(level) {
      if (level >= 4) {
        this.$router.push(this.toFloatAccount(level))
      } else {
        this.$router.push(this.to(level))
      }
    },
    to(level) {
      return {
        name: "Accounts",
        params: {
          level: level,
        },
      };

    },
    toFloatAccount(level) {
      if (level == 4) {
        return {
          name: "FloatAccountGroups",
        };
      } else {
        return {
          name: "FloatAccounts",
        };

      }

    },

  },

}
</script>

<style scoped lang="scss"></style>

